import { render, staticRenderFns } from "./PersonListLight.vue?vue&type=template&id=f9d509ea&scoped=true&"
import script from "./PersonListLight.vue?vue&type=script&lang=js&"
export * from "./PersonListLight.vue?vue&type=script&lang=js&"
import style0 from "./PersonListLight.vue?vue&type=style&index=0&id=f9d509ea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9d509ea",
  null
  
)

export default component.exports